// src/pages/DepartmanYonetimiPage.js
import React, { useState, useEffect, useCallback } from 'react';

const API = '';

const RENKLER = [
  '#4F46E5','#7C3AED','#DB2777','#DC2626','#D97706',
  '#059669','#0891B2','#2563EB','#64748B','#374151'
];

export default function DepartmanYonetimiPage() {
  const [departmanlar, setDepartmanlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState(null);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [form, setForm] = useState({
    ad: '', kod: '', aciklama: '', ust_departman_id: '', renk: '#4F46E5', sira: 0
  });

  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  const getir = useCallback(async () => {
    try {
      setYukleniyor(true);
      const r = await fetch(`${API}/api/organizasyon/departmanlar?hepsi=1`, { headers });
      const d = await r.json();
      setDepartmanlar(Array.isArray(d) ? d : []);
    } catch { setHata('Veriler yüklenemedi'); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => { getir(); }, [getir]);

  const yeniAc = () => {
    setSecili(null);
    setForm({ ad: '', kod: '', aciklama: '', ust_departman_id: '', renk: '#4F46E5', sira: 0 });
    setHata(''); setBasari('');
    setModalAcik(true);
  };

  const duzenleAc = (dep) => {
    setSecili(dep);
    setForm({
      ad: dep.ad, kod: dep.kod, aciklama: dep.aciklama || '',
      ust_departman_id: dep.ust_departman_id || '', renk: dep.renk || '#4F46E5', sira: dep.sira || 0
    });
    setHata(''); setBasari('');
    setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.ad.trim() || !form.kod.trim()) {
      setHata('Ad ve kod zorunludur'); return;
    }
    try {
      const url = secili
        ? `${API}/api/organizasyon/departmanlar/${secili.id}`
        : `${API}/api/organizasyon/departmanlar`;
      const method = secili ? 'PUT' : 'POST';
      const r = await fetch(url, { method, headers, body: JSON.stringify(form) });
      const d = await r.json();
      if (!r.ok) { setHata(d.hata || 'Hata oluştu'); return; }
      setBasari(d.mesaj); setHata('');
      setTimeout(() => { setModalAcik(false); getir(); }, 800);
    } catch { setHata('Sunucu hatası'); }
  };

  const sil = async (dep) => {
    if (!window.confirm(`"${dep.ad}" departmanını silmek istediğinize emin misiniz?`)) return;
    try {
      const r = await fetch(`${API}/api/organizasyon/departmanlar/${dep.id}`, { method: 'DELETE', headers });
      const d = await r.json();
      if (!r.ok) { alert(d.hata); return; }
      getir();
    } catch { alert('Hata oluştu'); }
  };

  const pasifToggle = async (dep) => {
    const eylem = dep.aktif ? 'pasife almak' : 'aktife almak';
    if (!window.confirm(`"${dep.ad}" departmanını ${eylem} istediğinize emin misiniz?`)) return;
    try {
      const r = await fetch(`${API}/api/organizasyon/departmanlar/${dep.id}/aktif`, {
        method: 'PUT', headers,
        body: JSON.stringify({ aktif: dep.aktif ? 0 : 1 })
      });
      const d = await r.json();
      if (!r.ok) { alert(d.hata || 'Hata oluştu'); return; }
      getir();
    } catch { alert('Hata oluştu'); }
  };

  // Otomatik kod üret
  const kodUret = (ad) => {
    return ad.toUpperCase()
      .replace(/Ğ/g,'G').replace(/Ü/g,'U').replace(/Ş/g,'S')
      .replace(/İ/g,'I').replace(/Ö/g,'O').replace(/Ç/g,'C')
      .replace(/[^A-Z0-9]/g,'').slice(0, 6);
  };

  return (
    <div style={{ padding: '24px', maxWidth: '1100px', margin: '0 auto' }}>
      {/* Başlık */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: '#111827', margin: 0 }}>
            🏢 Departman Yönetimi
          </h1>
          <p style={{ color: '#6B7280', marginTop: '4px', fontSize: '14px' }}>
            {departmanlar.length} departman tanımlı
          </p>
        </div>
        <button onClick={yeniAc} style={{
          background: '#4F46E5', color: '#fff', border: 'none',
          padding: '10px 20px', borderRadius: '8px', cursor: 'pointer',
          fontWeight: 600, fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px'
        }}>
          + Yeni Departman
        </button>
      </div>

      {/* Liste */}
      {yukleniyor ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#6B7280' }}>Yükleniyor...</div>
      ) : departmanlar.length === 0 ? (
        <div style={{
          textAlign: 'center', padding: '60px', background: '#F9FAFB',
          borderRadius: '12px', border: '2px dashed #E5E7EB'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>🏢</div>
          <p style={{ color: '#6B7280', fontWeight: 600 }}>Henüz departman yok</p>
          <button onClick={yeniAc} style={{
            marginTop: '12px', background: '#4F46E5', color: '#fff',
            border: 'none', padding: '8px 20px', borderRadius: '6px', cursor: 'pointer'
          }}>İlk departmanı oluştur</button>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '12px' }}>
          {departmanlar.map(dep => (
            <div key={dep.id} style={{
              background: '#fff', borderRadius: '10px',
              border: '1px solid #E5E7EB', padding: '16px 20px',
              display: 'flex', alignItems: 'center', gap: '16px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>
              {/* Renk şeridi */}
              <div style={{
                width: '4px', height: '48px', borderRadius: '2px',
                background: dep.renk || '#4F46E5', flexShrink: 0
              }} />

              {/* İkon */}
              <div style={{
                width: '40px', height: '40px', borderRadius: '8px',
                background: (dep.renk || '#4F46E5') + '20',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '18px', flexShrink: 0
              }}>🏢</div>

              {/* Bilgiler */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  <span style={{ fontWeight: 700, fontSize: '15px', color: '#111827' }}>{dep.ad}</span>
                  <span style={{
                    background: '#F3F4F6', color: '#374151', fontSize: '11px',
                    padding: '2px 8px', borderRadius: '4px', fontWeight: 600, fontFamily: 'monospace'
                  }}>{dep.kod}</span>
                  {dep.ust_departman_ad && (
                    <span style={{ color: '#6B7280', fontSize: '12px' }}>
                      ↑ {dep.ust_departman_ad}
                    </span>
                  )}
                </div>
                {dep.aciklama && (
                  <p style={{ color: '#6B7280', fontSize: '13px', margin: '2px 0 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {dep.aciklama}
                  </p>
                )}
              </div>

              {/* İstatistikler */}
              <div style={{ display: 'flex', gap: '16px', flexShrink: 0 }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: 700, color: '#4F46E5' }}>{dep.personel_sayisi || 0}</div>
                  <div style={{ fontSize: '11px', color: '#9CA3AF' }}>Personel</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: 700, color: '#059669' }}>{dep.pozisyon_sayisi || 0}</div>
                  <div style={{ fontSize: '11px', color: '#9CA3AF' }}>Pozisyon</div>
                </div>
              </div>

              {/* Aksiyonlar */}
              <div style={{ display: 'flex', gap: '8px', flexShrink: 0, alignItems: 'center' }}>
                {!dep.aktif && (
                  <span style={{ background: '#FEF3C7', color: '#92400E', fontSize: '11px', padding: '2px 8px', borderRadius: '99px', fontWeight: 700 }}>PASİF</span>
                )}
                <button onClick={() => duzenleAc(dep)} style={{
                  background: '#EEF2FF', color: '#4F46E5', border: 'none',
                  padding: '7px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px'
                }}>Düzenle</button>
                <button onClick={() => pasifToggle(dep)} style={{
                  background: dep.aktif ? '#FEF3C7' : '#F0FDF4', color: dep.aktif ? '#92400E' : '#16A34A', border: 'none',
                  padding: '7px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px'
                }}>{dep.aktif ? 'Pasife Al' : 'Aktife Al'}</button>
                <button onClick={() => sil(dep)} style={{
                  background: '#FEF2F2', color: '#DC2626', border: 'none',
                  padding: '7px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px'
                }}>Sil</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {modalAcik && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div style={{
            background: '#fff', borderRadius: '16px', padding: '32px',
            width: '100%', maxWidth: '500px', maxHeight: '90vh', overflowY: 'auto',
            boxShadow: '0 25px 50px rgba(0,0,0,0.25)'
          }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 24px' }}>
              {secili ? '✏️ Departman Düzenle' : '+ Yeni Departman'}
            </h2>

            {hata && (
              <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>
                ⚠️ {hata}
              </div>
            )}
            {basari && (
              <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>
                ✅ {basari}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {/* Ad */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>
                  Departman Adı *
                </label>
                <input
                  value={form.ad}
                  onChange={e => {
                    const ad = e.target.value;
                    setForm(f => ({ ...f, ad, kod: f.kod || kodUret(ad) }));
                  }}
                  placeholder="örn: Yazılım Geliştirme"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                />
              </div>

              {/* Kod */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>
                  Kod * <span style={{ fontWeight: 400, color: '#9CA3AF' }}>(benzersiz, max 6 karakter)</span>
                </label>
                <input
                  value={form.kod}
                  onChange={e => setForm(f => ({ ...f, kod: e.target.value.toUpperCase().slice(0,6) }))}
                  placeholder="örn: YAZILIM"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', fontFamily: 'monospace', boxSizing: 'border-box' }}
                />
              </div>

              {/* Üst Departman */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>
                  Üst Departman
                </label>
                <select
                  value={form.ust_departman_id}
                  onChange={e => setForm(f => ({ ...f, ust_departman_id: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                >
                  <option value="">— Üst departman yok —</option>
                  {departmanlar.filter(d => !secili || d.id !== secili.id).map(d => (
                    <option key={d.id} value={d.id}>{d.ad}</option>
                  ))}
                </select>
              </div>

              {/* Renk */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '8px' }}>
                  Renk
                </label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {RENKLER.map(r => (
                    <button
                      key={r} onClick={() => setForm(f => ({ ...f, renk: r }))}
                      style={{
                        width: '32px', height: '32px', borderRadius: '50%', background: r,
                        border: form.renk === r ? '3px solid #111827' : '3px solid transparent',
                        cursor: 'pointer', padding: 0
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Açıklama */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>
                  Açıklama
                </label>
                <textarea
                  value={form.aciklama}
                  onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))}
                  placeholder="Departman hakkında kısa açıklama..."
                  rows={3}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }}
                />
              </div>

              {/* Sıra */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>
                  Sıra (görünüm sırası)
                </label>
                <input
                  type="number" value={form.sira} min={0}
                  onChange={e => setForm(f => ({ ...f, sira: parseInt(e.target.value) || 0 }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                />
              </div>
            </div>

            {/* Butonlar */}
            <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              <button onClick={() => setModalAcik(false)} style={{
                flex: 1, padding: '11px', borderRadius: '8px', border: '1.5px solid #E5E7EB',
                background: '#fff', color: '#374151', cursor: 'pointer', fontWeight: 600
              }}>İptal</button>
              <button onClick={kaydet} style={{
                flex: 2, padding: '11px', borderRadius: '8px', border: 'none',
                background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '14px'
              }}>
                {secili ? 'Güncelle' : 'Oluştur'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
